import { useState } from 'react'
import DataTable from '../components/DataTable';
import { KTSVG } from '../../_metronic/helpers'
import Swal from 'sweetalert2'
import DealerManage from '../components/DealerManage';
import 'react-loading-skeleton/dist/skeleton.css';

function DealerList() {

    const hasPermission = 1; //parseInt(GetPagePermission("/setup-company-list"));
    const [newData, setNewData] = useState({});
    const [id, setId] = useState(0);

    const [createDealerModalShow, setCreateDealerModalShow] = useState(false);

    const handleCreateDealerModalShow = () => {
        setId(0);
        setCreateDealerModalShow(true);
    }

    const handleCreateDealerModalClose = (isReload: boolean) => {
        setCreateDealerModalShow(false);
        if (isReload) {
            setNewData({ id: Date.now() });
        }
    }

    const deleteDealer = async (id: number): void => {
        const confirm = await Swal.fire({
            title: 'Are you sure?',
            text: "You want to delete this Dealer?",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#ec008c',
            cancelButtonText: 'Cancel',
            confirmButtonText: 'Yes, Delete it!',
        })
        if (confirm.value) {
            const myToken: string | null = localStorage.getItem('MyToken');
            let jwt: string | null = (myToken != null) ? JSON.parse(myToken) : null;
            fetch(`${process.env.REACT_APP_API_URL}dealer/delete/${id}`, {
                method: 'DELETE',
                headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${jwt}` }
            })
            .then((resp: Response) => {
                return resp.json();
            })
            .then((resp: any) => {
                if (resp.success) {
                    const successMsg: string = resp.successMessage;
                    Swal.fire({
                        icon: 'success',
                        title: 'Deleted!',
                        text: successMsg,
                    });
                    setNewData({ id: Date.now() });
                }else{
                    const errorMsg: string = resp.errorMessage;
                    Swal.fire({
                        icon: 'error',
                        title: 'Delete Failed!',
                        text: errorMsg,
                    });
                }
            })
            .catch((error: any) => {
                Swal.fire({
                    icon: 'error',
                    title: 'Oops...',
                    text: 'Dealer not found!',
                });
                console.error('Error:', error);
            });
        }
        
    };

    const editDealer = (id: number): void => {
        console.log("Edit Dealer ID = ",id);
        console.log("ID = ",id);
        setId(id);
        setCreateDealerModalShow(true);
    };

    const columns = [
        { value: 'id', title: 'Id', style: { textAlign: 'center' } },
        { value: 'dealerName', title: 'Name', style: { textAlign: 'left' } },
        { value: 'projectName', title: 'Project', style: { textAlign: 'left' } },
        { value: 'issueDate', title: 'Issue Date', style: { textAlign: 'left' } },
        { value: 'dealerId', title: 'Dealership ID', style: { textAlign: 'left' } },
        { value: 'companyName', title: 'Client', style: { textAlign: 'left' } },
        { value: 'districtName', title: 'District', style: { textAlign: 'left' } },
        { value: 'upazilaName', title: 'Upazila', style: { textAlign: 'left' } },        
        { value: 'phoneNumber', title: 'Phone', style: { textAlign: 'left' } },
        { value: 'address', title: 'Address', style: { textAlign: 'left' } },
        {
            value: 'action', title: 'Action', style: { textAlign: 'left', whiteSpace: 'nowrap' }, hasActionsComponent: true, actionsComponent: ((row: any) => {
                return (
                    <>

                        <button className="btn btn-light-primary btn-sm" onClick={() => editDealer(row.id)}>
                            <KTSVG
                                path='/media/svg/icons/Communication/Write.svg'
                                className='svg-icon-5 svg-icon'
                            />		Edit
                        </button>

                        <button className="btn btn-light-danger btn-sm p-2" onClick={() => deleteDealer(row.id)}>
                            <KTSVG
                                path='/media/svg/icons/General/Trash.svg'
                                className='svg-icon-5 svg-icon'
                            />		Delete
                        </button>

                        <a className="btn btn-light-primary btn-sm" target="_blank" rel="noopener noreferrer" href={`${process.env.REACT_APP_BACKEND}dealerCertificateDownload/${row.id}`}>
                            <KTSVG
                                path='/media/svg/icons/Files/Downloads-folder.svg'
                                className='svg-icon-5 svg-icon'
                            />		Certificate
                        </a>
                    </>
                )
            })
        }
    ]

    const filters = {
        id: {
            filterType: 'like',
            filterValue: '',
        },
        dealerName: {
            filterType: 'like',
            filterValue: '',
        },
        projectName: {
            filterType: 'like',
            filterValue: '',
        },
        issueDate: {
            filterType: 'like',
            filterValue: '',
        },
        dealerId: {
            filterType: 'like',
            filterValue: '',
        },
        companyName: {
            filterType: 'like',
            filterValue: '',
        },
        districtName: {
            filterType: 'like',
            filterValue: '',
        },
        upazilaName: {
            filterType: 'like',
            filterValue: '',
        },
        phoneNumber: {
            filterType: 'like',
            filterValue: '',
        },
        address: {
            filterType: 'like',
            filterValue: '',
        },
    }

    const url = process.env.REACT_APP_API_URL + 'dealer/dt'

    return (
        <>
            {hasPermission === 1 &&
                <div className='card card-custom'>
                    <div className='card-header'>
                        <div className="card-title">
                            <KTSVG path='/media/svg/icons/Text/Bullet-list.svg' className='svg-icon-1 svg-icon-primary' />
                            <span className='text fw-bolder' style={{ marginLeft: '10px' }}>
                                Dealer List
                            </span>
                        </div>
                        <div className="card-toolbar">
                            <div className='d-flex justify-content-end'>
                                <button type="button" className="btn btn-sm btn-primary" onClick={() => handleCreateDealerModalShow()}><i className="fa fa-plus"></i> Add Dealer</button>
                            </div>
                        </div>
                    </div>

                    <div className='card-body'>
                        <DataTable url={url} columns={columns} filters={filters} newData={newData} />
                    </div>
                </div>
            }

            <DealerManage show={createDealerModalShow} handleClose={handleCreateDealerModalClose} id={id} />
        </>
    )
}

export default DealerList
